
import { defineComponent, reactive } from 'vue'

import { AxiosError } from 'axios'
import NewslettersSignupStepLayout from '~/components/NewslettersSignup/NewslettersSignupStepLayout.vue'
import AlFormGroup from '~/components/ui/AlFormGroup/AlFormGroup.vue'
import AlTextInput from '~/components/ui/AlTextInput/AlTextInput.vue'
import AlButton from '~/components/ui/AlButton/AlButton.vue'
import ButtonArrow from '~/components/ui/AlButton/ButtonArrow.vue'
import { $api } from '~/plugins/axios'
import { useLoading } from '~/composables/loading.composable'

export default defineComponent({
  name: 'NewslettersSignupEmail',
  components: {
    NewslettersSignupStepLayout,
    AlFormGroup,
    AlTextInput,
    AlButton,
    ButtonArrow,
  },
  emits: ['submit', 'failure'],
  setup () {
    const {
      isLoading,
      isError,
      setLoading,
      setError,
    } = useLoading()

    const form = reactive({
      email: '',
    })

    return {
      isLoading,
      isError,
      form,
      setLoading,
      setError,
    }
  },

  computed: {
    title () {
      return this.$t('newslettersSignup.step1.title')
    },
    subtitle () {
      return this.$t('newslettersSignup.step1.subtitle')
    },
  },

  methods: {
    async onSubmit () {
      const locale = this.$i18n.locale as string

      if (!await this.$validator.validate()) {
        return
      }

      this.setLoading(true)

      try {
        const subscription = await $api.LemurService.createSubscription(locale, this.form)
        this.$emit('submit', subscription.id)
        this.setError(false)
      } catch (e) {
        this.$emit('failure', e)

        // Do not count 409 as an error
        if ((e as AxiosError).response && (e as AxiosError).response?.status === 409) {
          return
        }

        this.$sentry.captureException(e)
        this.setError(true)
      } finally {
        this.setLoading(false)
      }
    },
  },
})

